import React, { FunctionComponent, SVGProps } from 'react'

export const IconAttention: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#F79009"
    strokeWidth="1.5"
    {...props}
  >
    <path
      d="M9.99935 18.3332C14.6017 18.3332 18.3327 14.6022 18.3327 9.99984C18.3327 5.39746 14.6017 1.6665 9.99935 1.6665C5.39698 1.6665 1.66602 5.39746 1.66602 9.99984C1.66602 14.6022 5.39698 18.3332 9.99935 18.3332Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 6.6665V9.99984" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M10 13.3335H10.0083"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
